import { routes } from '../../../routes';
import React from 'react';
import { Route } from '../../../../../utils/router';
import PageHeaderNav from '../../../components/PageHeaderNav';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import {
  useAllSentShiftChangeRequestsQuery,
  useAllReceivedChangeRequestsQuery,
  ShiftChangeRequestColleagueApprovalStatus,
  ShiftChangeRequestApprovalStatus,
} from '../../../__generated__/graphql';

type TabItem = {
  label: string;
  route: Route<string[]>;
};

const i18Path = 'schedulerShifts.tabs';

const SchedulerShiftsNav: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);
  // TODO let's optimize in another ticket by only fetching the pending requests, and update cache after mutations (create request, cancel request)
  const { data: sentData } = useAllSentShiftChangeRequestsQuery();
  const { data: receivedData } = useAllReceivedChangeRequestsQuery();

  const pendingSentCount =
    sentData?.me.shiftChangeRequestsFromMe?.filter(
      (request) =>
        request.flair__Approval_Status__c ===
        ShiftChangeRequestApprovalStatus.Pending,
    )?.length ?? 0;

  const pendingReceivedCount =
    receivedData?.me.shiftChangeRequestsToMe?.filter(
      (request) =>
        request.flair__Colleague_Approval_Status__c ===
        ShiftChangeRequestColleagueApprovalStatus.Pending,
    )?.length ?? 0;

  const tabItems: TabItem[] = [
    {
      label: t('calendar'),
      route: routes.schedulerShifts.route,
    },
    {
      label: t('colleagues'),
      route: routes.schedulerShiftsColleagues.route,
    },
    {
      label:
        pendingSentCount > 0
          ? `${t('sentChangeRequests')} (${pendingSentCount})`
          : t('sentChangeRequests'),
      route: routes.schedulerShiftsSentTransferRequests.route,
    },
    {
      label:
        pendingReceivedCount > 0
          ? `${t('receivedChangeRequests')} (${pendingReceivedCount})`
          : t('receivedChangeRequests'),
      route: routes.schedulerShiftsReceivedTransferRequests.route,
    },
  ];

  return <PageHeaderNav tabItems={tabItems} />;
};

export default SchedulerShiftsNav;
